"use client";

import markdownMap from "@/lib/markdownMap";
import ReactMarkdown from "react-markdown";
import { useParams, notFound, useRouter } from "next/navigation";
import { X } from "lucide-react";
import LoadingOverlay from "@/components/ui/LoadingOverlay";
import useMarkdownLoader from "@/hooks/useMarkdownLoader";

export default function MarkdownPage() {
  const { slug } = useParams<{ slug: string }>();
  const router = useRouter();
  
  const filePath = markdownMap[slug] || null;
  const { content, isLoading, error } = useMarkdownLoader({ 
    filePath,
    minLoadingTime: 600 // Délai minimum de 600ms pour une UX fluide
  });

  if (!markdownMap[slug]) return notFound();

  const handleClose = () => {
    router.back();
  };

  return (
    <LoadingOverlay isLoading={isLoading}>
      <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-2xl">
        <div className="relative bg-white rounded-xl shadow-xl w-full max-w-2xl p-0 animate-in fade-in-0 zoom-in-95 duration-300">
          {/* Close button */}
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 focus:outline-none bg-primary rounded-full p-2 transition-all duration-200 hover:scale-110 z-10"
            aria-label="Fermer"
            onClick={handleClose}
          >
            <X size={18} className="text-white" />
          </button>

          {/* Error state */}
          {error && (
            <div className="p-8 text-center">
              <div className="text-red-500 mb-4">
                <svg className="w-12 h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Erreur de chargement</h3>
              <p className="text-gray-600 mb-4">{error}</p>
              <button
                onClick={handleClose}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
              >
                Fermer
              </button>
            </div>
          )}

          {/* Content */}
          {content && !error && (
            <div className="prose max-h-[80vh] overflow-y-auto p-8 markdown fade-in-up">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </LoadingOverlay>
  );
} 